/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon16Solid = forwardRef('FoodDrinkAlcoGlassWineIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.75C2 1.784 2.784 1 3.75 1h8.5c.966 0 1.75.784 1.75 1.75v2a6.002 6.002 0 0 1-5 5.917V13h2.5a1 1 0 1 1 0 2h-7a1 1 0 1 1 0-2H7v-2.333A6.002 6.002 0 0 1 2 4.75v-2ZM12.5 4V2.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25V4h9Z" })));
});
